import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import {
  ApiService,
  isSystemSuperAdminFromToken,
  Profile,
  ProfileService,
  StorageService,
  SYSTEM_SUPER_ADMIN_HOME,
} from '@app-utils';
import {
  catchError,
  finalize,
  map,
  Observable,
  of,
  tap,
  throwError,
} from 'rxjs';
import { AppLoaderService } from '../services';

export const profileGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storageSvc = inject(StorageService);
  const apiSvc = inject(ApiService);
  const loaderSvc = inject(AppLoaderService);
  const profileSvc = inject(ProfileService);
  const token = storageSvc.getAuthToken();

  loaderSvc.setProfileLoader(true);
  const obs = (
    token
      ? apiSvc.getUserLoginDetail().pipe(
          map((res) => res.data),
          catchError((e) => {
            profileSvc.logout();
            void router.navigate(['/']);
            return throwError(e);
          }),
        )
      : of(null)
  ) as Observable<null | Profile>;
  const applyLoggedInSession = (userRes: Profile): void => {
    profileSvc.setProfile(userRes);
    profileSvc.setOrganizationList(userRes.organisation ?? []);
  };

  return obs.pipe(
    tap((userRes) => {
      if (!userRes && !state.url.includes('/auth')) {
        return void router.navigate(['auth']);
      }
      if (
        state.url.includes('/auth') &&
        userRes &&
        !state.url.includes('/auth/invitation') &&
        !state.url.includes('/auth/invite')
      ) {
        applyLoggedInSession(userRes);
        if (isSystemSuperAdminFromToken(storageSvc)) {
          return void router.navigateByUrl(SYSTEM_SUPER_ADMIN_HOME);
        }
        return void router.navigate(['/']);
      }

      if (!userRes) return;

      applyLoggedInSession(userRes);

      if (
        (state.url === '/' || state.url === '') &&
        isSystemSuperAdminFromToken(storageSvc)
      ) {
        return void router.navigateByUrl(SYSTEM_SUPER_ADMIN_HOME);
      }
      // token && setImage(userRes?.id || '').subscribe();
    }),
    map((data) => !!data),
    finalize(() => loaderSvc.setProfileLoader(false)),
  );
};
